import { Modal, ModalBody, ModalButtonContainer } from '@/components/modal/modal';
import { Button } from '@/components/button';
import styles from './styles.module.css';
import { usePostSubmitNavigation } from '@/hooks/use-post-submit-navigation';
import { VideoSvg } from '@/components/svgs/video';
import { useTranslation } from '@/contexts/i18n-context';

interface VideoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const translationBase = 'visit.providerSelection';

export function VideoModal({ isOpen, onClose }: VideoModalProps) {
  const { t } = useTranslation();
  const { navigatePostSubmit } = usePostSubmitNavigation();

  const handleConfirm = () => {
    onClose();
    navigatePostSubmit();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} className={styles.modal}>
      <VideoSvg className={styles.icon} />
      <h2 className="h4">{t(`${translationBase}.videoModal.title`)}</h2>
      <ModalBody>{t(`${translationBase}.videoModal.body`)}</ModalBody>
      <ModalButtonContainer>
        <Button onClick={handleConfirm}>{t('common.iUnderstand')}</Button>
      </ModalButtonContainer>
    </Modal>
  );
}
